import { render, staticRenderFns } from "./OneToManyChat.vue?vue&type=template&id=76e77e67"
import script from "./OneToManyChat.vue?vue&type=script&lang=ts"
export * from "./OneToManyChat.vue?vue&type=script&lang=ts"
import style0 from "./OneToManyChat.vue?vue&type=style&index=0&id=76e77e67&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports